import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

// A quiet, elegant placeholder for future modules that are not yet public.
export default function ComingSoon({ module }) {
  const { t } = useTranslation();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  // Module descriptors are localised via i18n (modules.<id>.*), falling back to
  // the English defaults in config/modules.js so a new module never renders blank.
  const id = module?.id;
  const category = id ? t(`modules.${id}.category`, { defaultValue: module?.category || t("comingSoon.defaultCategory") }) : t("comingSoon.defaultCategory");
  const name = id ? t(`modules.${id}.name`, { defaultValue: module?.name || t("comingSoon.defaultName") }) : t("comingSoon.defaultName");
  const tagline = id ? t(`modules.${id}.tagline`, { defaultValue: module?.tagline || t("comingSoon.defaultTagline") }) : t("comingSoon.defaultTagline");

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-24" data-testid={`coming-soon-${module?.id || "module"}`}>
      <div className="max-w-xl mx-auto px-6 text-center space-y-8">
        <span className="text-[10px] font-sans tracking-[0.3em] uppercase text-[var(--accent-bronze)] font-semibold block">
          {category}
        </span>
        <h1 className="text-4xl sm:text-5xl font-serif text-primary-custom tracking-tight leading-tight">
          {name}
        </h1>
        <p className="font-serif text-base sm:text-lg italic text-secondary-custom leading-relaxed font-light">
          {tagline}
        </p>
        <p className="font-sans text-xs text-secondary-custom leading-relaxed max-w-md mx-auto">
          {t("comingSoon.body")}
        </p>
        <div className="pt-2">
          <Link to="/" data-testid="coming-soon-home-link" className="inline-flex items-center gap-2 border border-primary px-8 py-3 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[var(--accent-bronze)] hover:text-white hover:border-[var(--accent-bronze)] transition-all duration-300">
            <ArrowLeft className="w-3.5 h-3.5" />
            <span>{t("comingSoon.returnHome")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
